//#region src/core/ui/time/data.ts
const TimeDataAttrs = {
	/** The type of time being displayed. */
	type: "data-type",
	/** Present when the time toggle is disabled. */
	disabled: "data-disabled",
	/** Present when the non-interactive time value is unavailable. */
	unavailable: "data-unavailable"
};
//#endregion
export { TimeDataAttrs };

//# sourceMappingURL=data.js.map